import DishesPackhouseComponent from './DishesPackhouse.component';
import DishesPackhouseContainer from './DishesPackhouse.container';

export default DishesPackhouseContainer(DishesPackhouseComponent);
